var _a;
import dayjs from 'dayjs';
import { AttendanceRecordType, AttendanceDisplayStatus } from '@/types/attendance';
export var getAttendanceStatusInfo = function (date, dayData) {
    var status = '-';
    var type = AttendanceRecordType.NONE;
    var isWeekend = date.day() === 0 || date.day() === 6;
    if (isWeekend) {
        status = '休日';
        type = AttendanceRecordType.HOLIDAY;
    }
    if (dayData) {
        type = AttendanceRecordType.NORMAL;
        switch (dayData.status) {
            case AttendanceRecordType.MISSING_STAMP:
                type = AttendanceRecordType.MISSING_STAMP;
                status = '未打刻';
                break;
            case AttendanceRecordType.PENDING_REQUEST:
                type = AttendanceRecordType.PENDING_REQUEST;
                status = '申請中';
                break;
            case AttendanceRecordType.HOLIDAY:
                type = AttendanceRecordType.HOLIDAY;
                status = '休日';
                break;
            case AttendanceRecordType.REQUEST_REJECTED:
                type = AttendanceRecordType.REQUEST_REJECTED;
                status = '差し戻し';
                break;
            case AttendanceRecordType.ADMIN_MODIFIED:
                type = AttendanceRecordType.ADMIN_MODIFIED;
                status = '管理者により修正';
                break;
            case AttendanceRecordType.REQUEST_APPROVED:
                type = AttendanceRecordType.REQUEST_APPROVED;
                status = '申請を受理';
                break;
            default:
                type = dayData.status;
                break;
        }
    }
    return { status: status, type: type };
};
export var extractTime = function (datetime) {
    var _a, _b;
    return (_b = (_a = datetime === null || datetime === void 0 ? void 0 : datetime.split(' ')[1]) === null || _a === void 0 ? void 0 : _a.slice(0, 5)) !== null && _b !== void 0 ? _b : '';
};
/**
 * Check whether to show checkout button
 * Show checkout if temp_checkin exists OR if already checked in but not checked out (check_out_at is null)
 * @param attendance - Attendance object or null
 * @returns true if checkout button should be shown, false otherwise
 */
export var shouldShowCheckout = function (attendance) {
    if (!attendance)
        return false;
    // Show checkout if temp_checkin exists
    if (attendance.temp_checkin)
        return true;
    // Show checkout if already checked in but not checked out
    if (attendance.check_in_at && !attendance.check_out_at)
        return true;
    return false;
};
/**
 * Mapping from status string from BE to display config
 */
export var STATUS_MAP = (_a = {},
    _a[AttendanceDisplayStatus.WORKED] = {
        getDisplayValue: function (h) { return h.toFixed(1); },
        showWarningIcon: false,
        cssClass: ''
    },
    _a[AttendanceDisplayStatus.PENDING_REQUEST] = {
        getDisplayValue: function (h) { return h.toFixed(1); },
        showWarningIcon: true,
        cssClass: 'attendance-request'
    },
    _a[AttendanceDisplayStatus.NOT_ASSIGNED] = {
        getDisplayValue: function () { return '0.0'; },
        showWarningIcon: false,
        cssClass: ''
    },
    _a[AttendanceDisplayStatus.MISSING_STAMP] = {
        getDisplayValue: function () { return '未入場'; },
        showWarningIcon: false,
        cssClass: 'absent'
    },
    _a[AttendanceDisplayStatus.MISSING_CHECKOUT] = {
        getDisplayValue: function () { return '未退場'; },
        showWarningIcon: false,
        cssClass: 'absent'
    },
    _a[AttendanceDisplayStatus.HOLIDAY] = {
        getDisplayValue: function () { return '-'; },
        showWarningIcon: false,
        cssClass: 'weekend'
    },
    _a[AttendanceDisplayStatus.WORKING] = {
        getDisplayValue: function () { return '0.0'; },
        showWarningIcon: false,
        cssClass: ''
    },
    _a[AttendanceDisplayStatus.NOT_ENTERED] = {
        getDisplayValue: function () { return '0.0'; },
        showWarningIcon: false,
        cssClass: ''
    },
    _a);
var mapStatusToDisplay = function (statusString, workHours, day, projectStartDate) {
    // Convert string to enum (BE returns string that matches enum values)
    var status = statusString;
    var config = STATUS_MAP[status] || STATUS_MAP[AttendanceDisplayStatus.NOT_ENTERED];
    var dayDate = dayjs(day.date);
    var isFutureDay = dayDate.isAfter(dayjs(), 'day');
    var isHoliday = status === AttendanceDisplayStatus.HOLIDAY;
    var isBeforeProjectStart = false;
    if (projectStartDate) {
        var startDate = dayjs(projectStartDate);
        var isPastDay = dayDate.isBefore(dayjs(), 'day');
        isBeforeProjectStart = isPastDay && dayDate.isBefore(startDate, 'day');
    }
    var shouldHide = (isFutureDay && !isHoliday) || (isBeforeProjectStart && !isHoliday);
    return {
        status: status,
        displayValue: shouldHide && !workHours ? ' ' : config.getDisplayValue(workHours),
        workHours: status === AttendanceDisplayStatus.WORKED ||
            status === AttendanceDisplayStatus.PENDING_REQUEST
            ? workHours
            : 0,
        showWarningIcon: config.showWarningIcon,
        cssClass: config.cssClass
    };
};
export var getAttendanceDisplayData = function (workDay, day, projectStartDate) {
    if (!workDay) {
        var statusString = dayjs(day.date).isBefore(dayjs(), 'day')
            ? AttendanceDisplayStatus.NOT_ASSIGNED
            : AttendanceDisplayStatus.NOT_ENTERED;
        return mapStatusToDisplay(statusString, 0, day, projectStartDate);
    }
    return mapStatusToDisplay(workDay.status, workDay.work_hours, day, projectStartDate);
};
